var TECL_Event = {
    ProcessClick: function(e, productCode, sessionId, sessionStartDate, sessionTownOrCity, sessionSpacesAvailable) {
        //set the variables on the delegates form
        $("#eventProductCode").val(productCode);
        $("#eventSessionId").val(sessionId);
        $("#numberOfAttendees").val(1);
        $("#eventDateAndLocation").text(sessionStartDate + ' in ' + sessionTownOrCity);

        //Set max spaces
        $("#eventNumberOfAttendees").attr("max", sessionSpacesAvailable);
        $("#eventSessionSpacesAvailable").text(sessionSpacesAvailable);

        //show delegates modal
        $("#eventBookingModal").modal("toggle");
    }
    ,
    AddDelegate: function(e, sessionId, allowDelete) {
        e.preventDefault();
        //Get the current number of delegates
        var numberOfDelegates = $("#numberOfDelegates").val();
        //increment number of delegates
        numberOfDelegates++;

        //Hide the remove button on previous delegates
        $(".removeDelegateButton").hide();

        //get the element to add container div to
        var $formFields = $("#addDelegateContent" + sessionId);

        //create the container div
        $('<div id="additionalDelegate' + numberOfDelegates + '"></div>').appendTo($formFields);

        //Get the container div reference
        var $container = $("#additionalDelegate" + numberOfDelegates);

        //Call the server to generate the additional fields (including metadata questions)
        var url = "/umbraco/Surface/EventSurface/GenerateAdditionalDelegateFormFields";
        $.ajax({
            url: url,
            data: {
                sessionId: sessionId,
                delegateNumber: numberOfDelegates,
                allowDelete: allowDelete
            },
            cache: false,
            type: "POST",
            success: function(data) {
                if (data.length !== 0) {
                    $(data.ResultString).appendTo($container);
                    //Set the number of delegates back on the form
                    $("#numberOfDelegates").val(numberOfDelegates);
                }
            },
            error: function(xhr, status, error) {
                console.log(xhr.responseText);
                alert("message : \n" +
                	"An error occurred, for more info check the js console" +
                  	"\n status : \n" + status + " \n error : \n" + error);
            }
        });
    }
    ,
    DisplayError: function(errorMessage) {
        alert(errorMessage);
    }
    ,
    ShowBasketResult: function(e) {
        $("#basketResultModal").modal("show");
    }
    ,
    RemoveDelegate: function(e, delegateNumber) {
        //Get the element to remove (remove both additional and initally generated delegates).
        $("#delegateDetails" + delegateNumber).remove();
        $("#additionalDelegate" + delegateNumber).remove();

        //Set the number of delegates back on the form
        $("#numberOfDelegates").val(delegateNumber - 1);

        //unhide the previous element's delete button
        $("#removeDelegateButton" + (delegateNumber - 1)).show();
    }
    ,
    UpdateBasketBookingPrice: function(productPriceExcVat) {
        var quantity = $("#eventNumberOfAttendees").val();
        $("#eventBookingTotalPrice").text((quantity * productPriceExcVat).toFixed(2));
    }
    //,
    //ShowAddedToCart: function (sessionName, sessionTownOrCity, bookingId, sessionId) {

    //    $("#addedToBasketSessionDescription").text(sessionName + " - " + sessionTownOrCity);
    //    $("#addAttendeeDetailsButton")
    //        .attr("onclick", "TECL_Event.ShowDelegatesBooking('" + bookingId + "', '" + sessionId + "');");

    //    $("#eventAddedToBasketModal").modal("toggle");
    //}
    ,
    ShowDelegatesBooking: function(sessionName, sessionTownOrCity, bookingId, sessionId) {
        $("#addedToBasketSessionDescription").text(sessionName + " - " + sessionTownOrCity);
        //$("#eventAddedToBasketModal").modal("hide");
        $("#bookingId").val(bookingId);
        $("#sessionId").val(sessionId);
        $("#addDelegateModal" + sessionId).modal("toggle");
    }
    ,
    ShowAccountLogIn: function() {
        $("#eventAccountLoginForm").show();
        $("#eventAccountDetails").hide();
        $("#eventBookingInformation").hide();
    }
    ,
    ShowAccountRegister: function() {
        $("#eventAccountDetails").show();
        $("#eventBookingInformation").show();
        $("#eventAccountLoginForm").hide();
    }
    ,
    AddressSearch: function() {
        $("#AddressResult_Error").hide();
        var url = "/umbraco/Surface/WebAccountSurface/AddressSearch";
        var schoolName = "";
        var postcode = $("input[name='searchPostcode']").val();
        var town = "";
        var rollNumber = "";
        var country = "";
        var addressCollectionMethod = $("input[name='registerLocation']:checked").val();
        var registerAddressType = $("input[name='registerAddressType']:checked").val();

        $.ajax({
            url: url,
            data: {
                schoolName: schoolName,
                postcode: postcode,
                town: town,
                rollNumber: rollNumber,
                country: country,
                registerAddressType: registerAddressType,
                addressCollectionMethod: addressCollectionMethod
            },
            dataType: 'json',
            cache: true,
            type: "POST",
            success: function(data) {

                var dropDown = $("#addressDropDown");
                var dropDownGroup = $("#addressDropdownGroup");
                if (data.Addresses.length !== 0) {
                    //Populate dropdown
                    dropDown.empty();
                    if (data.Type === "SCHOOL") {
                        $.each(data.Addresses,
                            function(index) {
                                $(document.createElement('option'))
                                    .attr('value', data.Addresses[index].Id)
                                    .text(data.Addresses[index].OrgName +
                                        ', ' +
                                        data.Addresses[index].Address1 +
                                        ', ' +
                                        data.Addresses[index].Town +
                                        ', ' +
                                        data.Addresses[index].Postcode)
                                    .appendTo(dropDown);
                            });
                    } else {
                        $.each(data.Addresses,
                            function(index) {
                                $(document.createElement('option'))
                                    .attr('value', data.Addresses[index].PostKey)
                                    .text(data.Addresses[index].AddressText)
                                    .appendTo(dropDown);
                            });
                    }
                    //unhide dropdown
                    dropDownGroup.fadeIn(1000);
                    dropDown.fadeIn(1000);
                    //Hide no results message
                    $("#AddressResult_NoResults").hide();
                } else {
                    //Clear and hide dropdown
                    dropDown.empty();
                    dropDownGroup.hide(500);
                    dropDown.hide(500);
                    //Show no results message
                    $("#AddressResult_NoResults").show(500);
                }
            },
            error: function(xhr, status, error) {
                console.log(xhr.responseText);
                $("#AddressResult_Error").show(500);
                alert("message : \n" +
                    "An error occurred, for more info check the js console" +
                    "\n status : \n" + status + " \n error : \n" + error);
            }
        });
    }
    ,
    FillAttendee1: function(title, firstName, lastName, email) {
        if (document.getElementById("populateAttendee1").checked) {
            $("#delegateTitle1").val(title);
            $("#delegateFirstName1").val(firstName);
            $("#delegateLastName1").val(lastName);
            $("#delegateEmail1").val(email);
        }
    }
};